import { useEffect, useState } from "react";
import Select from "react-select";
import "./WaitlistOrder.scss";

const customStyles = {
  container: base => ({
    ...base,
    width: "160px",
    marginRight: "14px"
  }),
  singleValue: base => ({
    ...base,
    fontSize: "14px"
  }),
  option: base => ({
    ...base,
    fontSize: "14px"
  })
};

const options = [
  {
    value: "check-in",
    label: "Check-in Time"
  },
  {
    value: "priority",
    label: "Priority"
  },
  {
    value: "time-left",
    label: "Time Left"
  }
];

const WaitlistOrder = ({ isEdit, listOrder, setListOrder }) => {
  useEffect(() => {
    if (!listOrder) {
      setListOrder(options[0]);
    }
  }, []);

  useEffect(() => {
    if (isEdit) {
      setListOrder(options[1]);
    }
  }, [isEdit]);

  return (
    <div className="wl-order">
      <div className="wl-order__row">
        <Select
          onChange={setListOrder}
          styles={customStyles}
          value={listOrder}
          options={options}
          isSearchable={false}
        />
      </div>
    </div>
  );
};

export default WaitlistOrder;
